
import { Vue, Component, Prop } from 'vue-property-decorator';
import { getPrice } from '@/features/common/helpers';
import { AvailableService } from '@/features/shipment/types';

@Component
export default class EstimateCostBreakdown extends Vue {
  @Prop({ required: true }) service!: AvailableService;

  @Prop({ required: false, default: '#8B8BAC' }) color!: string;

  @Prop({ required: false, default: false }) showSavings!: boolean;

  private getPrice: (val: number, to: number) => string = getPrice;

  get taxPrices(): { gstOrHst: number, qst: number} {
    return {
      gstOrHst: this.getTaxPrice(['HST', 'GST']),
      qst: this.getTaxPrice(['QST']),
    };
  }

  get baseShippingRate(): number {
    if (!this.service.charges) return 0;
    const baseRate = this.service.charges.find(
      (charge) => charge.name.toLowerCase() === 'Base Rate'.toLowerCase(),
    );
    if (!baseRate) return 0;
    return baseRate.amount;
  }

  get otherCharges(): { name: string, amount: number }[] {
    if (!this.service.charges) return [];
    const rates = this.service.charges.filter(
      (charge) => charge.name.toLowerCase() !== 'Base Rate'.toLowerCase(),
    );
    if (!rates) return [];
    return rates;
  }

  private getTaxPrice(names: string[]): number {
    return names.includes(this.service.taxDetails.name)
      ? this.service.taxDetails.amount
      : 0;
  }
}
